import { render } from "./AppRibbon.vue?vue&type=template&id=bf8388f8&scoped=true&lang=pug"
import script from "./AppRibbon.vue?vue&type=script&lang=js"
export * from "./AppRibbon.vue?vue&type=script&lang=js"

import "./AppRibbon.vue?vue&type=style&index=0&id=bf8388f8&lang=scss&scoped=true"

import exportComponent from "/Users/edsonfer/Documents/dev-projects/node-projects/portal-gignet-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf8388f8"]])

export default __exports__